<template>
  <section class="header">
    <header class="header-box" :class="[{'scroll': menuStatus},{'homeBg': $route.name !== 'agendaview'&& !menuStatusMobile}]">
      <div class="header-wrap">
        <h1 class="logo">
          <router-link to="/">
            <svg version="1.1" class="hide" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 159.8 36.5" style="enable-background:new 0 0 159.8 36.5;" xml:space="preserve">
            <g>
              <path class="st0" d="M154,11.2c-1.7,0-3-0.2-3.9-0.7c-0.7-0.4-1.3-1-1.6-1.7c-0.4-0.7-0.6-1.7-0.7-3.1c-0.2-1.7-0.4-2.8-0.5-3.3
                h-5.5c0.2,0.7,0.4,1.8,0.6,3.5c0.1,1,0.2,1.7,0.3,2.3c0.1,0.5,0.3,1,0.6,1.6c0.4,0.7,0.8,1.2,1.3,1.6c0.5,0.4,1.1,0.7,2,1
                c-0.9,0.3-1.6,0.7-2,1c-0.5,0.4-0.9,0.9-1.3,1.6c-0.3,0.6-0.5,1.1-0.6,1.6c-0.1,0.5-0.2,1.3-0.3,2.3c-0.1,1.7-0.3,2.8-0.6,3.5h5.5
                c0.2-0.5,0.3-1.6,0.5-3.3c0.1-1.3,0.4-2.4,0.7-3.1c0.4-0.7,0.9-1.3,1.6-1.7c0.9-0.5,2.2-0.7,3.9-0.7V11.2z"/>
              <path class="st0" d="M102.7,11.2c1.7,0,3-0.2,3.9-0.7c0.7-0.4,1.3-1,1.6-1.7c0.4-0.7,0.6-1.7,0.7-3.1c0.2-1.7,0.4-2.8,0.5-3.3h5.5
                c-0.2,0.7-0.4,1.8-0.6,3.5c-0.1,1-0.2,1.7-0.3,2.3c-0.1,0.5-0.3,1-0.6,1.6c-0.4,0.7-0.8,1.2-1.3,1.6c-0.5,0.4-1.1,0.7-2,1
                c0.9,0.3,1.6,0.7,2,1c0.5,0.4,0.9,0.9,1.3,1.6c0.3,0.6,0.5,1.1,0.6,1.6c0.1,0.5,0.2,1.3,0.3,2.3c0.1,1.7,0.3,2.8,0.6,3.5h-5.5
                c-0.2-0.5-0.3-1.6-0.5-3.3c-0.1-1.3-0.4-2.4-0.7-3.1c-0.4-0.7-0.9-1.3-1.6-1.7c-0.9-0.5-2.2-0.7-3.9-0.7V11.2z"/>
              <polygon points="138.3,2.4 118.4,2.4 118.4,6.5 125.9,6.5 125.9,22.3 130.8,22.3 130.8,6.5 138.3,6.5 	"/>
              <path d="M158.9,2.4h-11.8c0.2,0.5,0.3,1.6,0.5,3.3c0,0.3,0.1,0.6,0.1,0.8h11.1V2.4z"/>
              <path d="M147.2,22.3h11.8v-4.1h-11.1c0,0.3-0.1,0.5-0.1,0.8C147.5,20.7,147.4,21.8,147.2,22.3z"/>
              <path d="M96,2.4v19.9h4.9V6.5h8c0-0.3,0.1-0.5,0.1-0.8c0.2-1.7,0.4-2.8,0.5-3.3H96z"/>
              <path class="st0" d="M97.8,31.6H96v-1.4H98l0.5-3.1h-2.1v-1.4h10.1v1.4h-1.5v3.1h1.9v1.4h-1.9v4.1h-1.7v-4.1h-3.9l-0.6,4.1h-1.7
                L97.8,31.6z M99.7,30.2h3.7v-3.1h-3.2L99.7,30.2z"/>
              <path class="st0" d="M113,28.8l-0.2,0.7h6.4v1.3h0l0,0c-0.5,1.3-1.2,2.4-2.1,3.1c0.4,0.1,0.7,0.3,1.1,0.3c0.4,0.1,0.8,0.1,1.3,0.2
                v1.3c-0.8,0-1.5-0.1-2.1-0.2c-0.6-0.1-1.2-0.4-1.8-0.7c-0.5,0.2-1,0.4-1.6,0.6c-0.6,0.2-1.2,0.3-1.9,0.3v-1.5
                c0.4-0.1,0.8-0.1,1.1-0.2c0.4-0.1,0.7-0.2,1-0.3c-0.6-0.6-1.2-1.5-1.8-2.5h1.7c0.4,0.7,0.9,1.3,1.5,1.8c0.4-0.3,0.7-0.6,1-1
                c0.3-0.4,0.6-0.8,0.8-1.3l0,0l-5.1,0l-1.7,4.9l-1.7,0.1l2.5-7h-0.8H109l0.9-3.1h1.6l-0.5,1.7h0.9l0.6-1.7l1.7-0.1l-0.6,1.8h4
                L117,26h1.7l0.9,2.7h-0.8h-0.9H113z"/>
              <path class="st0" d="M121.4,31.6l1.4-2.2h-1.2v-1.4h4.7v-0.7H122V26h4.3v-0.4h1.7V26h4.2v1.4H128v0.7h2.8l0.2-0.5h1.4l-0.2,0.5h0.4
                v1.4h-8l-0.4,0.7h7.8v2.1v1.4v0.6c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.4,0.3
                c-0.2,0.1-0.3,0.1-0.5,0.1h-8v-4.1H121.4z M124.3,31.5v0.7h5.9v-0.7H124.3z M130.2,33.5h-5.9v0.8h5.5c0.1,0,0.2,0,0.3-0.1
                c0.1-0.1,0.1-0.2,0.1-0.3V33.5z"/>
              <path class="st0" d="M139.6,32.8h-1.4l-0.4-1.5v4.4h-1.6v-3.2h-1.4l2.2-4.3h-1.9v-1.4l1,0l-0.4-1.1h1.8l0.4,1.1h1.7l-1.5,3h0.7
                L139.6,32.8z M143.7,29.5v4.8h2v1.4h-5.8v-1.4h2.1v-4.8h-2.1v-1.4h2.1v-2.4h1.7v2.4h2v1.4H143.7z"/>
              <path class="st0" d="M149.3,35.7c-0.3,0-0.6-0.1-0.9-0.4c-0.2-0.3-0.4-0.6-0.4-0.9V27v-1.2v-0.1h10.9V27h-9.1v7
                c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1h8.8l-0.4,1.3H149.3z M150.4,32.3c0.5-0.1,0.9-0.2,1.4-0.4c0.4-0.1,0.8-0.3,1.2-0.5
                c-0.5-0.5-0.9-1.1-1.3-1.7c-0.4-0.6-0.8-1.3-1.1-2.1h1.8c0.3,0.6,0.7,1.1,1,1.6c0.3,0.5,0.7,0.9,1.1,1.2c0.4-0.3,0.7-0.7,1.1-1.2
                c0.3-0.5,0.7-1,1-1.6h1.8c-0.4,0.8-0.7,1.5-1.1,2.1c-0.4,0.6-0.8,1.2-1.3,1.7c0.4,0.2,0.8,0.3,1.2,0.5c0.4,0.1,0.9,0.3,1.4,0.4V34
                c-0.8-0.1-1.6-0.3-2.2-0.5c-0.7-0.2-1.3-0.5-1.8-0.8c-0.5,0.3-1.1,0.6-1.8,0.8c-0.7,0.2-1.4,0.4-2.2,0.5V32.3z"/>
              <g>
                <path d="M32.1,5.8V2.2l-13.7,0V0L18,0c-1.3,0.2-2.5,0.9-3.2,2.1l-14.3,0v3.6h13.7l0,2.4l-11.8,0v3.6h27.8V8.2l-11.8,0V5.8H32.1z"
                  />
                <path d="M68.3,5.9c-0.2-2-1.8-3.5-3.8-3.7H36.7l0,32l0.3,0c1.9-0.3,3.8-1.7,3.8-4.3l0-24h22.4c0.5,0,1,0.4,1,1c0,0,0,21.6,0,21.6
                  c0,1.8-1,3.4-2.4,4.3l2.8,3.1c2.3-1.7,3.7-4.3,3.7-7.3L68.3,5.9z"/>
                <path d="M63.1,9.9l-0.3-0.1c-1.6-0.5-3.7-0.2-4.7,1.9L56.9,14l-1.3-2.5c0,0,0,0,0,0c-0.3-0.7-0.8-1.2-1.3-1.5c0,0,0,0,0,0
                  c-0.5-0.3-1.1-0.5-1.8-0.5c-0.7,0-1.3,0.2-1.8,0.5c0,0,0,0-0.1,0c-0.5,0.3-0.9,0.8-1.3,1.5c0,0,0,0,0,0c0,0,0,0,0,0L48.1,14
                  l-1.2-2.4c-1-2-3.1-2.4-4.7-1.9l-0.3,0.1L46,18l-4.2,8.2l0.3,0.1c1.6,0.5,3.7,0.2,4.7-1.9l1.2-2.4l1.3,2.5c0,0,0,0,0,0
                  c0,0,0,0,0,0c0.3,0.7,0.8,1.1,1.3,1.5c0,0,0,0,0.1,0c0.5,0.3,1.1,0.5,1.8,0.5c0.7,0,1.3-0.2,1.8-0.5c0,0,0,0,0,0
                  c0.5-0.3,1-0.8,1.3-1.5c0,0,0,0,0,0l1.3-2.5l1.2,2.4c1,2,3.1,2.4,4.7,1.9l0.3-0.1L58.9,18L63.1,9.9z M52.5,22.6L50.1,18l2.4-4.6
                  l2.4,4.6L52.5,22.6z"/>
                <path d="M30.2,14.2l-27.8,0c0,0,0,14.1,0,14.1c0,1.8-1,3.4-2.4,4.3l2.8,3.1c2.3-1.7,3.7-4.3,3.7-7.3v-3.4h19.9
                  c2-0.2,3.6-1.8,3.8-3.7L30.2,14.2z M6.5,17.8h7.7l0,3.4H6.5V17.8z M26.1,20.4c0,0.5-0.4,0.9-0.9,0.9h-6.8v-3.4h7.7L26.1,20.4z"/>
              </g>
              <rect x="81.9" y="2.2" class="st1" width="0.5" height="33.5"/>
            </g>
            </svg>
            <svg version="1.1" class="show" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 159.8 36.5" style="enable-background:new 0 0 159.8 36.5;" xml:space="preserve">
            <g>
              <path class="st0" d="M154,11.2c-1.7,0-3-0.2-3.9-0.7c-0.7-0.4-1.3-1-1.6-1.7c-0.4-0.7-0.6-1.7-0.7-3.1c-0.2-1.7-0.4-2.8-0.5-3.3
                h-5.5c0.2,0.7,0.4,1.8,0.6,3.5c0.1,1,0.2,1.7,0.3,2.3c0.1,0.5,0.3,1,0.6,1.6c0.4,0.7,0.8,1.2,1.3,1.6c0.5,0.4,1.1,0.7,2,1
                c-0.9,0.3-1.6,0.7-2,1c-0.5,0.4-0.9,0.9-1.3,1.6c-0.3,0.6-0.5,1.1-0.6,1.6c-0.1,0.5-0.2,1.3-0.3,2.3c-0.1,1.7-0.3,2.8-0.6,3.5h5.5
                c0.2-0.5,0.3-1.6,0.5-3.3c0.1-1.3,0.4-2.4,0.7-3.1c0.4-0.7,0.9-1.3,1.6-1.7c0.9-0.5,2.2-0.7,3.9-0.7V11.2z"/>
              <path class="st0" d="M102.7,11.2c1.7,0,3-0.2,3.9-0.7c0.7-0.4,1.3-1,1.6-1.7c0.4-0.7,0.6-1.7,0.7-3.1c0.2-1.7,0.4-2.8,0.5-3.3h5.5
                c-0.2,0.7-0.4,1.8-0.6,3.5c-0.1,1-0.2,1.7-0.3,2.3c-0.1,0.5-0.3,1-0.6,1.6c-0.4,0.7-0.8,1.2-1.3,1.6c-0.5,0.4-1.1,0.7-2,1
                c0.9,0.3,1.6,0.7,2,1c0.5,0.4,0.9,0.9,1.3,1.6c0.3,0.6,0.5,1.1,0.6,1.6c0.1,0.5,0.2,1.3,0.3,2.3c0.1,1.7,0.3,2.8,0.6,3.5h-5.5
                c-0.2-0.5-0.3-1.6-0.5-3.3c-0.1-1.3-0.4-2.4-0.7-3.1c-0.4-0.7-0.9-1.3-1.6-1.7c-0.9-0.5-2.2-0.7-3.9-0.7V11.2z"/>
              <polygon points="138.3,2.4 118.4,2.4 118.4,6.5 125.9,6.5 125.9,22.3 130.8,22.3 130.8,6.5 138.3,6.5 	"/>
              <path d="M158.9,2.4h-11.8c0.2,0.5,0.3,1.6,0.5,3.3c0,0.3,0.1,0.6,0.1,0.8h11.1V2.4z"/>
              <path d="M147.2,22.3h11.8v-4.1h-11.1c0,0.3-0.1,0.5-0.1,0.8C147.5,20.7,147.4,21.8,147.2,22.3z"/>
              <path d="M96,2.4v19.9h4.9V6.5h8c0-0.3,0.1-0.5,0.1-0.8c0.2-1.7,0.4-2.8,0.5-3.3H96z"/>
              <path class="st0" d="M97.8,31.6H96v-1.4H98l0.5-3.1h-2.1v-1.4h10.1v1.4h-1.5v3.1h1.9v1.4h-1.9v4.1h-1.7v-4.1h-3.9l-0.6,4.1h-1.7
                L97.8,31.6z M99.7,30.2h3.7v-3.1h-3.2L99.7,30.2z"/>
              <path class="st0" d="M113,28.8l-0.2,0.7h6.4v1.3h0l0,0c-0.5,1.3-1.2,2.4-2.1,3.1c0.4,0.1,0.7,0.3,1.1,0.3c0.4,0.1,0.8,0.1,1.3,0.2
                v1.3c-0.8,0-1.5-0.1-2.1-0.2c-0.6-0.1-1.2-0.4-1.8-0.7c-0.5,0.2-1,0.4-1.6,0.6c-0.6,0.2-1.2,0.3-1.9,0.3v-1.5
                c0.4-0.1,0.8-0.1,1.1-0.2c0.4-0.1,0.7-0.2,1-0.3c-0.6-0.6-1.2-1.5-1.8-2.5h1.7c0.4,0.7,0.9,1.3,1.5,1.8c0.4-0.3,0.7-0.6,1-1
                c0.3-0.4,0.6-0.8,0.8-1.3l0,0l-5.1,0l-1.7,4.9l-1.7,0.1l2.5-7h-0.8H109l0.9-3.1h1.6l-0.5,1.7h0.9l0.6-1.7l1.7-0.1l-0.6,1.8h4
                L117,26h1.7l0.9,2.7h-0.8h-0.9H113z"/>
              <path class="st0" d="M121.4,31.6l1.4-2.2h-1.2v-1.4h4.7v-0.7H122V26h4.3v-0.4h1.7V26h4.2v1.4H128v0.7h2.8l0.2-0.5h1.4l-0.2,0.5h0.4
                v1.4h-8l-0.4,0.7h7.8v2.1v1.4v0.6c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.4,0.3
                c-0.2,0.1-0.3,0.1-0.5,0.1h-8v-4.1H121.4z M124.3,31.5v0.7h5.9v-0.7H124.3z M130.2,33.5h-5.9v0.8h5.5c0.1,0,0.2,0,0.3-0.1
                c0.1-0.1,0.1-0.2,0.1-0.3V33.5z"/>
              <path class="st0" d="M139.6,32.8h-1.4l-0.4-1.5v4.4h-1.6v-3.2h-1.4l2.2-4.3h-1.9v-1.4l1,0l-0.4-1.1h1.8l0.4,1.1h1.7l-1.5,3h0.7
                L139.6,32.8z M143.7,29.5v4.8h2v1.4h-5.8v-1.4h2.1v-4.8h-2.1v-1.4h2.1v-2.4h1.7v2.4h2v1.4H143.7z"/>
              <path class="st0" d="M149.3,35.7c-0.3,0-0.6-0.1-0.9-0.4c-0.2-0.3-0.4-0.6-0.4-0.9V27v-1.2v-0.1h10.9V27h-9.1v7
                c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1h8.8l-0.4,1.3H149.3z M150.4,32.3c0.5-0.1,0.9-0.2,1.4-0.4c0.4-0.1,0.8-0.3,1.2-0.5
                c-0.5-0.5-0.9-1.1-1.3-1.7c-0.4-0.6-0.8-1.3-1.1-2.1h1.8c0.3,0.6,0.7,1.1,1,1.6c0.3,0.5,0.7,0.9,1.1,1.2c0.4-0.3,0.7-0.7,1.1-1.2
                c0.3-0.5,0.7-1,1-1.6h1.8c-0.4,0.8-0.7,1.5-1.1,2.1c-0.4,0.6-0.8,1.2-1.3,1.7c0.4,0.2,0.8,0.3,1.2,0.5c0.4,0.1,0.9,0.3,1.4,0.4V34
                c-0.8-0.1-1.6-0.3-2.2-0.5c-0.7-0.2-1.3-0.5-1.8-0.8c-0.5,0.3-1.1,0.6-1.8,0.8c-0.7,0.2-1.4,0.4-2.2,0.5V32.3z"/>
              <g>
                <path d="M32.1,5.8V2.2l-13.7,0V0L18,0c-1.3,0.2-2.5,0.9-3.2,2.1l-14.3,0v3.6h13.7l0,2.4l-11.8,0v3.6h27.8V8.2l-11.8,0V5.8H32.1z"
                  />
                <path d="M68.3,5.9c-0.2-2-1.8-3.5-3.8-3.7H36.7l0,32l0.3,0c1.9-0.3,3.8-1.7,3.8-4.3l0-24h22.4c0.5,0,1,0.4,1,1c0,0,0,21.6,0,21.6
                  c0,1.8-1,3.4-2.4,4.3l2.8,3.1c2.3-1.7,3.7-4.3,3.7-7.3L68.3,5.9z"/>
                <path d="M63.1,9.9l-0.3-0.1c-1.6-0.5-3.7-0.2-4.7,1.9L56.9,14l-1.3-2.5c0,0,0,0,0,0c-0.3-0.7-0.8-1.2-1.3-1.5c0,0,0,0,0,0
                  c-0.5-0.3-1.1-0.5-1.8-0.5c-0.7,0-1.3,0.2-1.8,0.5c0,0,0,0-0.1,0c-0.5,0.3-0.9,0.8-1.3,1.5c0,0,0,0,0,0c0,0,0,0,0,0L48.1,14
                  l-1.2-2.4c-1-2-3.1-2.4-4.7-1.9l-0.3,0.1L46,18l-4.2,8.2l0.3,0.1c1.6,0.5,3.7,0.2,4.7-1.9l1.2-2.4l1.3,2.5c0,0,0,0,0,0
                  c0,0,0,0,0,0c0.3,0.7,0.8,1.1,1.3,1.5c0,0,0,0,0.1,0c0.5,0.3,1.1,0.5,1.8,0.5c0.7,0,1.3-0.2,1.8-0.5c0,0,0,0,0,0
                  c0.5-0.3,1-0.8,1.3-1.5c0,0,0,0,0,0l1.3-2.5l1.2,2.4c1,2,3.1,2.4,4.7,1.9l0.3-0.1L58.9,18L63.1,9.9z M52.5,22.6L50.1,18l2.4-4.6
                  l2.4,4.6L52.5,22.6z"/>
                <path d="M30.2,14.2l-27.8,0c0,0,0,14.1,0,14.1c0,1.8-1,3.4-2.4,4.3l2.8,3.1c2.3-1.7,3.7-4.3,3.7-7.3v-3.4h19.9
                  c2-0.2,3.6-1.8,3.8-3.7L30.2,14.2z M6.5,17.8h7.7l0,3.4H6.5V17.8z M26.1,20.4c0,0.5-0.4,0.9-0.9,0.9h-6.8v-3.4h7.7L26.1,20.4z"/>
              </g>
              <rect x="81.9" y="2.2" class="st1" width="0.5" height="33.5"/>
            </g>
            </svg>
            <!-- <img class="show" src="@/assets/images/logo.png" alt=""/>
            <img class="hide" src="@/assets/images/logo1.png" alt=""/> -->
          </router-link>
        </h1>
        <div class="header-right">
          <ul class="navs">
            <li><router-link to="/2022/guest">大会嘉宾</router-link></li>
            <li><router-link to="/2022/agenda">大会议程</router-link></li>
            <li>
              <a href="javascript:;" @click="routerHome(1)">往届回顾</a>
              <!-- <ol class="navs-menu-li" @mouseover="scroll.stop()" @mouseleave="scroll.start()">
                <li><a href="#">RTE 2021</a></li>
                <li><a href="#">RTE 2020</a></li>
                <li><a href="javascript:;" @click="routerHome(3)">RTC 2019</a></li>
                <li><a href="javascript:;" @click="routerHome(4)">RTC 2018</a></li>
                <li><a href="javascript:;" @click="routerHome(5)">RTC 2017</a></li>
                <li><a href="javascript:;" @click="routerHome(6)">RTC 2016</a></li>
                <li><a href="javascript:;" @click="routerHome(7)">RTC 2015</a></li>
              </ol> -->
            </li>
          </ul>
          <!-- <div class="sign-up">
            <a target="_block" href="https://www.bagevent.com/event/8278845">立即报名</a>
          </div> -->
          <div class="menubtn" :class="{'active': menuStatusMobile}" @click="menuToggle()"><span></span></div>
        </div>
      </div>
      <div class="mobile-navs" :class="{'show': menuStatusMobile}">
        <div class="mobile-navs-wrap">
          <ul class="mobile-navs-list">
            <li><router-link to="/2022/guest">大会嘉宾</router-link></li>
            <li><router-link to="/2022/agenda">大会议程</router-link></li>
            <li :class="{'now': toggeleStatus}">
              <a href="javascript:;" @click="routerHome(1)">往届回顾</a>
              <!-- <ol class="mobile-leval-navs">
                <li><a href="#">RTE 2020</a></li>
                <li><a href="#">RTE 2021</a></li>
                <li><a href="javascript:;" >RTC 2019</a></li>
                <li><a href="javascript:;" @click="routerHome(4)">RTC 2018</a></li>
                <li><a href="javascript:;" @click="routerHome(5)">RTC 2017</a></li>
                <li><a href="javascript:;" @click="routerHome(6)">RTC 2016</a></li>
                <li><a href="javascript:;" @click="routerHome(7)">RTC 2015</a></li>
              </ol> -->
            </li>
          </ul>
          <div class="sign-meblie">
            <a target="_block" href="https://www.bagevent.com/event/8278845">立即报名</a>
          </div>
        </div>
      </div>
    </header>
  </section>
</template>

<script>
export default {
  data () {
    return {
      menuStatusMobile: false,
      menuShow: false,
      scrollY: 0,
      toggeleStatus: false
    }
  },
  props: {
    menuStatus: Boolean,
    scroll: Object
  },
  methods: {
    menuToggle () {
      this.menuStatusMobile = !this.menuStatusMobile
      if(this.menuStatusMobile) {
        this.scroll.stop()
        window.document.body.style.overflow = "hidden";
      }else{
        window.document.body.style.overflow = "visible";
      }
    },
    scrollBac () {
      setTimeout(() => {
        this.scroll.on('scroll', (args) => {
          const scrollTop = args.scroll.y
          const scroll = scrollTop - this.scrollY
          this.scrollY = scrollTop
          if (scrollTop >= 10) {
            if (scroll < 0) {
              this.menuShow = false
            } else {
              this.menuShow = true
            }
          }
        })
      })
    },
    mtoggles () {
      this.toggeleStatus = !this.toggeleStatus
    },
    // mouseoverHeader () {
    //   this.menuShow = false
    // },
    routerHome () {
      this.$router.push({ path: '/' })
      setTimeout(() => {
        this.scroll.update()
        const target = document.querySelector('#review')
        this.scroll.scrollTo(target, { duration: 0 })
        this.menuStatusMobile = false
        window.document.body.style.overflow = "visible";
      }, 900)
    }
  },
  mounted () {
    this.scrollBac()
  },
  watch: {
    $route (to, from) {
      this.menuStatusMobile = false
      this.scrollY = 0
      window.document.body.style.overflow = "visible";
    }
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/common/index.less");
  // .cls-1{fill:#000;}
  // .cls-2{fill:none;stroke:#271915;stroke-miterlimit:10;stroke-width:2.09px;}
  .st0{fill:#232323;}
  .st1{opacity:0.35;}
  .hide{
    g,path{fill:#fff;}
  }
</style>
